import {useParams} from 'react-router-dom'
import {hksvloadUserProfileByCustIdNow} from "../actionspwa/hkprofileActions"

//import React, { useState } from 'react';

import React, { lazy, useRef,useEffect, useState, useContext, useReducer, useCallback, Suspense } from 'react';
import hkprofileReducer from "../reducerspwa/hkprofileReducer"

import {ProfilecosmosContainerCom} from '../containers'
import SVAbodeSpinner from '../components/core/SVAbodeSpinner';
/*
const LazyProileContainerPage = lazy(() =>
  import('../views/LazyProfileComPage')   
  
);

const svLazyComponent = (page, svparams) => {
    switch (page) {
      case "LazyProfileComPage":
        return <LazyProileContainerPage svparams={svparams} />;
      
      default:
        return <div>404</div>;
    }
  };
*/
const LazyProfilecosmosContainerComPage = lazy(() =>
ProfilecosmosContainerCom
);

function SVProfileComPage() {
    let { id } = useParams();
    const svparams = { 'id': id}

    let  filtersInit= {
        loading: false,
        error: false,
       
        errob :{
          "timestamp": "2015-08-23T02:27:18.038+0000",
          "status": 500,
          "error": "Default Error",
          "message": "500 null",
          "path": "/kk/svaddressDetailPost"
      },
        my_data_geo:{
            "countryTypes": [
                {
                    "name": "United STates America",
                    "a2": "US",
                    "a3": "USA",
                    "value": "USA",
                    "isonum": "840"
                },
                {
                    "name": "Canada",
                    "isdcode": "01",
                    "a2": "CA",
                    "a3": "CAN",
                    "value": "CAN",
                    "isonum": "124"
                }
            ],
            "stateTypes": [
                {
                    "name": "California",
                    "value": "CA",
                    "a2": "CA"
                },
                {
                    "name": "New York",
                    "value": "NY",
                    "a2": "NY"
                },
                {
                    "name": "Texas",
                    "value": "TX",
                    "a2": "TX"
                }
            ],
            "isdcodeTypes": [
                {
                    "name": "United States Of America(+1)",
                    "value": "1"
                },
                {
                    "name": "Australia(+61)",
                    "value": "61"
                },
                {
                    "name": "Spain(+34)",
                    "value": "34"
                }
            ],
            "genderTypes": [
                {
                    "name": "CL_MALE",
                    "value": "MALE"
                },
                {
                    "name": "CL_FEMALE",
                    "value": "FEMALE"
                }
            ]
        },
        my_data_usercreddet: {
            "id": -1,
            "username": "pet123@yahoo.com",
            "password": "pet123"
        },
        my_data_profile:{
            "id": -11,
            "username": "",
            "password": "",
            "addressId": -1,
            "customerId": -1,
            "name": "",
            "fname": "",
            "lname": "",
            "phone": "",
            "email": "",
            "login": "SVDEFAULT_NO_USER",
           
            "otherDetails": "",
            "city": "",
            "state": "",
            "country": "usa",
            "address": null,
            "zipcode": "",
            "isdcode": "1",
            "token":"ssDEFAULT",
            "MMtokenBAK": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwYXltZW50TWV0aG9kQ29kZSI6ImNhcmQiLCJuYW1lIjoiam9uYiIsImZuYW1lIjoiam9uIiwibG5hbWUiOiJiZXRhIiwicGhvbmUiOiI1MTIxMjM0MzIyIiwiZW1haWwiOiJqb25AeWFob28uY29tIiwiYWRkcmVzcyI6IjEyIGxpbnZvYyIsImxvZ2luIjoiam9uQHlhaG9vLmNvbSIsInBhc3N3b3JkIjoiUGV0ZTEyMyIsInBhc3N3b3JkbWlycm9yIjoiUGV0ZTEyMyIsImVuY3Bhc3N3b3JkIjoiUGV0ZTEyMyIsIm90aGVyRGV0YWlscyI6Ik5lZWQgcGlja3VwIiwiaXNkY29kZSI6IjEiLCJjdXN0b21lcklkIjo3LCJjcmVhdGVkQnkiOiJBYm9kZVN5c3RlbUFkbWluIiwibW9kaWZpZWRCeSI6IkFib2RlU3lzdGVtQWRtaW4iLCJjcmVhdGVkRGF0ZSI6IjIwMjQtMDctMTNUMDE6NDk6MzQuMDAwKzAwMDAiLCJtb2RpZmllZERhdGUiOiIyMDI0LTA3LTEzVDAxOjQ5OjM0LjAwMCswMDAwIiwiaWF0IjoxNzI0MjEwMjE4LCJleHAiOjE3MjQyMTM4MTh9.y29VFr0Ixli6xRJizR2-kqYvf5PEFMtxbM4s3WUJquc",
    
            "addressType": "B",
            "createdDate": null,
            "modifiedDate": null,
            "createdBy": null,
            "modifiedBy": null
        }
       
    }
 
//let credob ={"usercredNew":{"customerId":"7"}}
  // const [filters, setFilters] = useState(filtersInit)
    
    const [{loading, error, my_data_geo,my_data_profile,my_data_usercreddet}, dispatch]= useReducer(hkprofileReducer, filtersInit);
    const getProfileCB = useCallback((credob)=>{
        console.log('useCallback*****getProfileCB***rqValues')
        console.log(credob)
        
        hksvloadUserProfileByCustIdNow(dispatch,credob)
    },[dispatch])
/*

    const getDinoCB = useCallback(() => {
        console.log('Step 2 - reactses useCall back fired');
        loadFscpageAction(dispatch);
    }, [dispatch]);
*/

    useEffect(() => {
        console.log('Step 1 - uses effect filter changes render container SVFlySearcComPage');
        let credob ={"usercredNew":{"customerId":"8"}}
        let myob =  credob.usercredNew
        if(svparams  ){
            myob['customerId'] =  svparams.id
        }
        console.log(svparams)
       
        getProfileCB(credob)
       
    }, [ getProfileCB]);

    console.log('SV*********r2*SVProfileComPage',svparams)
    /*
    return (
        <LazyProfilecosmosContainerComPage svparams= {svparams} hk_data_profile={my_data_profile} hk_data_geo={my_data_geo} />
    );
*/
    
         return (
        <ProfilecosmosContainerCom svparams= {svparams} hk_data_profile={my_data_profile} hk_data_geo={my_data_geo} />
    );

    
   /*

    let page = "LazyProfileComPage"
    return(
        <Suspense fallback={<SVAbodeSpinner/>}>
           {svLazyComponent(page, svparams)}
        </Suspense>
    )
    */
}
export default SVProfileComPage